// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sidebar-box[data-v-35ccaf24] {\n  position: relative;\n  overflow: hidden;\n  transition: max-heighe ease-in-out 0.2s;\n}\n.sidebar-box .read-more[data-v-35ccaf24] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  text-align: center;\n  margin: 0;\n  padding: 20px 0;\n\n  background-image: linear-gradient(to bottom, transparent, var(--v-background-base));\n}\n", ""]);
// Exports
module.exports = exports;
